import { UserManager } from "oidc-client-ts";

import { config } from "../../../config";

export const handleLoginRedirect = async () => {
  const runsInIframe = window?.parent && window.parent !== window;

  if (runsInIframe) {
    new UserManager({
      authority: `${config.login.authority}`,
      client_id: `${config.login.clientId}`,
      redirect_uri: `${config.login.redirectUri}`,
      filterProtocolClaims: false,
    }).signinSilentCallback();
  } else {
    window.location.href = window.location.href.replace("/redirect", "/");
  }
};
